<!--  <app-page-header [header]="'Quotations'" [breadcrumbs]="[
    {label: 'Home',       url: '/'},
    {label: 'Quotation List', url: '/quotation-cart'}
]"></app-page-header> -->
<div class="block">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-3 d-flex">
                <div class="account-nav flex-grow-1">
                    <h4 class="account-nav__title">Navigation</h4>
                    <ul>
                        <li *ngFor="let link of links" class="account-nav__item" routerLinkActive="account-nav__item--active" [routerLinkActiveOptions]="{exact: true}">
                            <a *ngIf="link.label!=='Logout'"  [routerLink]="link.url">{{ link.label }}</a>
                            <a *ngIf="link.label =='Logout'"  (click)="logout()">{{ link.label }}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-lg-9 mt-4 mt-lg-0">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

